<p-dialog
  [(visible)]="showModal"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '420px' }"
  styleClass="contact-dialog"
  header="Contact Details"
  (onHide)="closeModal()"
>
<div class="dialog-header-actions" *ngIf="userData?.isInternal">
      <app-qep-button
          icon="pi pi-user-plus"
          label="Add Contact"
          (click)="addContact()"
          (keydown.enter)="addContact()">
      </app-qep-button>
  </div>
  <!-- Profile Header Card -->
  <div class="profile-card">

  <!-- (Photo + Name section) -->
  <div class="profile-top">
    <div class="profile-photo-wrapper">
      <img
        *ngIf="safePhotoUrl"
        [src]="safePhotoUrl"
        alt="Profile"
        class="profile-photo"
      />
      <div *ngIf="!safePhotoUrl" class="profile-placeholder">
        {{ displayName | userInitials }}
      </div>
      <input
        type="file"
        accept="image/*"
        #fileInput
        style="display: none"
        (change)="onPhotoSelected($event)"
      />
    </div>

    <div class="profile-info">
      <div class="name-row">
        <ng-container *ngIf="isEditing; else showText">
          <div class="field-box">
            <span class="field-label">FIRST NAME</span>
            <input
              *ngIf="isEditing"
              type="text"
              [(ngModel)]="editableUserData.firstName"
              class="field-input"
            />
          </div>
          <div class="field-box">
            <span class="field-label">LAST NAME</span>
            <input
              *ngIf="isEditing"
              type="text"
              [(ngModel)]="editableUserData.lastName"
              class="field-input"
            />
          </div>
        </ng-container>
        <ng-template #showText>
          <div class="profile-name">
            {{ displayName }}
          </div>
        </ng-template>
        <div class="profile-icons" *ngIf="!isEditing && userInRole">
          <i class="pi pi-pencil icon edit" *ngIf="!userData?.isInternal" (click)="startEditing()"></i>
          <i class="pi pi-trash icon edit" (click)="deleteContact()"></i>
        </div>
      </div>

      <!-- VIEW MODE role/department -->
      <div *ngIf="!isEditing" class="profile-role-dept">
        <div class="profile-title">{{ jobTitle }}</div>
        <div class="profile-department" *ngIf="company">
          {{ company }}
        </div>
      </div>
    </div>
  </div>

  <!-- EDIT MODE -->
  <div *ngIf="isEditing" class="profile-edit-bottom">
      <div class="field-box">
          <span class="field-label">JOB TITLE</span>
          <input
            *ngIf="isEditing"
            type="text"
            [(ngModel)]="editableUserData.jobTitle"
            class="field-input"
          />
      </div>
      <div class="field-box" >
          <span class="field-label">DEPARTMENT</span>
          <input
            *ngIf="isEditing"
            type="text"
            [(ngModel)]="editableUserData.company"
            class="field-input"
          />
      </div>
  </div>

</div>
  <!-- Details Section -->
  <div class="details">
    <!-- Email -->
    <div class="detail-row" *ngIf="email || isEditing">
      <div class="w-100">
        <div class="label" *ngIf="!isEditing">EMAIL</div>
        <div class="field-box" *ngIf="isEditing">
          <span class="field-label">EMAIL</span>
          <input
            type="email"
            [(ngModel)]="editableUserData.email"
            name="email"
            #emailCtrl="ngModel"
            required
            [pattern]="emailPattern"
            class="field-input"
          />
           <!-- Inline validation messages -->
          <small class="p-error"
                *ngIf="emailCtrl?.invalid && (emailCtrl?.dirty || emailCtrl?.touched)">
                <span *ngIf="emailCtrl?.errors?.['required']">
                  Email is required
                </span>
                <span *ngIf="emailCtrl.errors?.['pattern']">
                    Enter a valid email address
                </span>
          </small>
        </div>
        <div *ngIf="!isEditing" class="value">{{ email }}</div>
      </div>
      <i class="pi pi-envelope detail-icon" *ngIf="email && !isEditing" (click)="sendEmail()"></i>
    </div>

    <!-- Office -->
    <div class="detail-row" *ngIf="userData?.officeLocation || isEditing">
      <div class="w-100">
        <div class="label" *ngIf="!isEditing">OFFICE</div>
        <div class="field-box" *ngIf="isEditing">
          <span class="field-label">OFFICE</span>
          <input
            *ngIf="isEditing"
            type="text"
            [(ngModel)]="editableUserData.officeLocation"
            class="field-input"
          />
        </div>
        <div *ngIf="!isEditing" class="value">{{ userData.officeLocation }}</div>
      </div>
    </div>

    <!-- Business Phone -->
    <div class="detail-row" *ngIf="userData?.businessPhone || isEditing">
      <div class="w-100">
        <div class="label" *ngIf="!isEditing">BUSINESS PHONE</div>
        <div class="field-box" *ngIf="isEditing">
          <span class="field-label">BUSINESS PHONE</span>
          <input
            *ngIf="isEditing"
            type="text"
            [(ngModel)]="editableUserData.businessPhone"
            class="field-input"
          />
        </div>
        <div *ngIf="!isEditing" class="value">{{ userData?.businessPhone }}</div>
      </div>
      <i class="pi pi-phone detail-icon" *ngIf="!isEditing" (click)="callPhone(false)" onKeyDown="callPhone(false)"></i>
    </div>

    <!-- Mobile Phone -->
     <div class="detail-row" *ngIf="userData?.mobilePhone || isEditing">
      <div class="w-100">
        <div class="label" *ngIf="!isEditing">MOBILE PHONE</div>
        <div class="field-box" *ngIf="isEditing">
          <span class="field-label">MOBILE PHONE</span>          
          <div *ngIf="isEditing">
            <ngx-intl-tel-input
              [cssClass]="'custom-mobile-number'"
              [customPlaceholder]="'Mobile number'"
              [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true"
              [enablePlaceholder]="true"
              [searchCountryFlag]="true"
              [selectedCountryISO]="CountryISO.Us"
              [maxLength]="15"
              [phoneValidation]="true"
              [numberFormat]="PhoneNumberFormat.National"
              name="mobilePhone"
              [(ngModel)]="editableUserData.mobilePhone"
              #mobilePhone="ngModel"
              (ngModelChange)="changeMobilePhone($event, mobilePhone)">
            </ngx-intl-tel-input>

            <div>
              <!-- Error only -->
              <small *ngIf="isMobileInvalid" class="p-error">Please enter a valid mobile number</small>
            </div>
          </div>
        </div>
        <div *ngIf="!isEditing" class="value">{{ userData?.mobilePhone }}</div>
      </div>
      <i class="pi pi-phone detail-icon" *ngIf="!isEditing" (click)="callPhone(true)" onKeyDown="callPhone(true)"></i>
    </div>
  </div>
  <div class="modal-footer" *ngIf="isEditing" class="flex justify-content-end flex-wrap card-container flex-gap" >
     <button pButton type="button" label="Cancel" (click)="closeModal()" class="p-button-secondary" ></button>
    <div>
        <button pButton type="button" label="Save" (click)="saveChanges()"  [disabled]="!hasChanges || isMobileInvalid || !isFormValid()"
          pTooltip="No changes detected"
          tooltipPosition="top"
          [tooltipDisabled]="hasChanges"
          class="p-button-primary" ></button>
    </div>
  </div>
</p-dialog>

<p-dialog  [contentStyle]="{'overflow': 'visible'}" 
    [(visible)]="showAddContactDialog" 
    [modal]="true" 
    [style]="{width: '420px'}" 
    [header]="'Add Contact'"
    *ngIf="showAddContactDialog">
    <app-add-contact [addContactDetails]="addContactObj"
    (closeDialog)="addContactClose($event)"></app-add-contact>
</p-dialog>